export const FA = {
    fa: "فارسی",
    en: "English",
    fr: "Français",
    login: "ورود",
    existEmail: "این ایمیل قبلا ثبت شده.",
    existMobile: "این شماره موبایل قبلا ثبت شده.",
    emptyEmail: "ایمیل خود را وارد کنید.",
    emptyMobile: "شماره موبایل خود را وارد کنید.",
    wrongEmail: "فرمت ایمیل اشتباه است.",
    wrongMobile: "فرمت شماره موبایل اشتباه است.",
    emptyEmailOrMobile: "ایمیل خود را وارد کنید.",
    loginError: "ایمیل یا رمزعبور اشتباه است.",
    emailOrMobile: "شماره موبایل",
    first_name: "نام",
    last_name: "نام‌خانوادگی",
    full_name: "نام و نام‌خانوادگی",
    phone: "شماره تلفن",
    passwordConfirm: "تکرار رمزعبور",
    passwordStrength: "حداقل ۶ کاراکتر، شامل عدد و حروف",
    passwordChanged: "رمزعبور با موفقیت تغییر کرد.",
    currentPasswordError: "رمزعبور فعلی صحیح نیست.",
    currentPassword: "رمزعبور فعلی",
    register: "ثبت‌نام",
    doRegister: "ثبت‌نام کنید",
    dontHaveAccount: "حساب کاربری ندارید؟",
    haveAccount: "حساب کاربری دارید؟",
    forgetPass: "فراموشی رمز عبور",
    loginWithToken: "ورود با شماره موبایل",
    password: "رمزعبور",
    backToLogin: "بازگشت به صفحه ورود",
    doLogin: "وارد شوید!",
    rules: "قوانین و مقررات",
    withRegistering: "با ثبت نام در این سایت",
    privacyPolicy: "قوانین حریم خصوصی",
    privacyPolicyConfirmation: "آن را می‌پذیرم.",
    mobile: "شماره همراه",
    mobileSample: "مثل 09123456789",
    email: "ایمیل",
    sms: "پیام کوتاه",
    verifyEmail: "تایید ایمیل",
    registerSuccess: "کاربر با موفقیت ثبت شد.",
    registerError: "خطا در ایجاد کاربر",
    youLoggedOff: "شما از پنل خارج شدید",
    mobileVerified: "شماره موبایل شما تایید شد.",
    wrongToken: "کد تایید اشتباه است. ",
    mobileVerify: "تایید موبایل",
    verifyMobile: "تایید شماره موبایل",
    sendTokenText1: "رمز یکبارمصرف شما به شماره",
    sendTokenText2: "ارسال شد.",
    sendTokenTextResend: "رمز یکبار مصرف مجددا برای شما ارسال شد.",
    sendTokenText3: "زمان باقی مانده تا ارسال مجدد پیامک",
    logOut: "خروج از سایت",
    confirm: "تایید",
    token: "کد تایید",
    forgetPassword: "فراموشی رمزعبور",
    invalidMobileNumber: "این شماره در سیستم وجود ندارد",
    recoverPassword: "بازیابی رمزعبور",
    recoverPasswordText: "برای بازیابی رمز عبور، شماره موبایل خود را وارد کنید.",
    sendAgain: "ارسال دوباره",
    changePassword: "تغییر رمزعبور",
    managePassword: "مدیریت رمزعبور",
    newPassword: "رمزعبور جدید",
    newPasswordConfirm: "تکرار رمزعبور جدید",
    loginWithUserPass: "ورود با رمز‌عبور",
    addYourNumberFirst: "برای ورود به سایت، شماره موبایل خود را وارد کنید.",
    errorHappens: "در بارگذاری سایت خطایی رخ داده است!",
    allChangesSaved: "تمام تغییرات ذخیره شد.",
    allChangesSavingFailed: "ذخیره سازی تغییرات با مشکل مواجه شد!",
    connectionError: 'اینترنت شما قطع است.',
    pleaseCheckTheBox: "لطفا قوانین را تایید کنید!",
    emptyField: 'فیلد خالی است.',
    noMatchPassword: 'رمزعبور مطابقت ندارد.',
    makingTokenError: "در ایجاد کد تایید مشکلی به وجود آمده است. ",
    editMobile: "تغییر شماره موبایل",
    editMobileDesc: "در صورتی که قصد تغییر شماره موبایل خود (",
    editMobileDesc2: ") را دارید، آن را وارد کنید.",
    save: "ذخیره",
    wrongPass: "تکرار رمزعبور اشتباه است",
    dataAdded: "اطلاعات شما ایجاد شد.",
    dataAddingFailed: "در ایجاد اطلاعات مشکلی به وجود آمده است.",
    emptyPassword: "رمز عبور را وارد کنید.",
    unreadNotifications: "خوانده نشده",
    readNotifications: "خوانده شده",
    noNotifications: "اعلانی وجود ندارد!",
    nothingFound: "صفحه وجود ندارد!",
    markAsRead: 'خوانده شد!',
    copyright: " تمام حقوق محفوظ است © ",
    dashboard: "داشبورد",
    account: "حساب کاربری",
    fileManager: "مدیریت فایل‌ها",
    myDetails: "اطلاعات من",
    myAccount: "حساب کاربری",
    doYouWanaExit: "آیا قصد خروج دارید؟",
    doYouWanaDelete: "آیا قصد حذف سوال را دارید؟",
    doYouWanaDeleteMatch: "آیا قصد حذف مسابقه را دارید؟",
    readMore: "بیشتر بخوانید!",
    areYouSure: "آیا از انجام این کار مطمئنید؟",
    yes: "بله",
    no: "خیر",
    userPanel: "پنل کاربری",
    userMobileIsConfirmed: "شماره موبایل کاربر تایید شده است.",
    userMobileIsNotConfirmed: "شماره موبایل کاربر تایید نشده است.",
    doYouWanaConfirm: "شماره موبایل کاربر را تایید می‌کنید؟",
    loginToUserAccount: "ورود به اکانت این کاربر",
    userShouldConfirmMobileFirst: "ابتدا باید شماره موبایل کاربر تایید شود!",
    youAreInSomeOneAccount: "شما در حساب کاربری فرد دیگری هستید!",
    backToMyAccount: "بازگشت",
    setDetails: "ثبت اطلاعات",
    paymentMethodsSettings: "روش‌های پرداخت",
    paymentMethodsRestaurants: "رستوران‌ها",
    paymentMethodsMarkets: "مارکت‌ها",
    paymentMethodsWalletDeposit: "شارژ کیف پول (ادمین / وب)",
    paymentGatewayParam: "Param",
    paymentGatewayIyzipay: "Iyzipay",
    paymentMethodsSaveChanges: "ذخیره تغییرات",
    paymentMethodsConfirmTitle: "تغییر روش پرداخت",
    paymentMethodsConfirmIntro: "آیا از ذخیره روش‌های پرداخت زیر مطمئن هستید؟",
    paymentMethodsConfirmRestaurants: "رستوران‌ها",
    paymentMethodsConfirmMarkets: "مارکت‌ها",
    paymentMethodsConfirmWallet: "شارژ کیف پول",
    paymentMethodsSaved: "روش‌های پرداخت ذخیره شد.",
    paymentMethodsSaveFailed: "ذخیره روش پرداخت ناموفق بود.",
    iyzipayPayTitle: "پرداخت با Iyzipay",
    iyzipayPayRedirect: "رفتن به صفحه پرداخت Iyzipay",
    iyzipayPayDescription: "پرداخت در صفحه امن Iyzipay انجام می‌شود (بدون کارت ذخیره‌شده).",
    detailsSet: "اطلاعات ثبت شد.",
    detailsSetFailed: "ثبت اطلاعات با مشکل مواجه شد.",
    detailsGetFailed: "دریافت اطلاعات با مشکل مواجه شد.",
    someFieldsHasErrorPleaseCheckThem: "یک یا چند فیلد دارای خطا هستند، لطفا بررسی نمایید",
    someFieldsHasError: "یک یا چند فیلد دارای خطا هستند، لطفا بررسی کنید",
    maxLength70: "طول این فیلد نباید بیش از ۷۰ کاراکتر باشد.",
    maxLength150: "طول این فیلد نباید بیش از ۱۵۰ کاراکتر باشد.",
    maxLength255: "طول این فیلد نباید بیش از ۲۵۵ کاراکتر باشد.",
    maxLength450: "طول این فیلد نباید بیش از ۴۵۰ کاراکتر باشد.",
    maxLength500: "طول این فیلد نباید بیش از ۵۰۰ کاراکتر باشد.",
    maxLength1000: "طول این فیلد نباید بیش از ۱۰۰۰ کاراکتر باشد.",
    chooseMedia: "انتخاب رسانه",
    submitErrorFile: "فایل ارسالی مشکل دارد.",
    imageSizeWidth700: "عرض مناسب تصویر 700px می‌باشد.",
    thumbnailSize: " حداقل عرض مناسب 600px",
    userAvatarSet: "تصویر پروفایل شما بروز شد.",
    avatar: "تصویر پروفایل",
    profileImage: "تصویر پروفایل",
    userAvatarSetFailed: "در تغییر تصویر پروفایل مشکلی به وجود آمده است.",
    loadingThumbnailFailed: "در بارگذاری تصویر مشکلی پیش آمده",
    ChooseImageLink: " برای کپی لینک، سایز مورد نظر را انتخاب کنید.",
    deleteFile: "فایل با موفقیت حذف شد",
    deleteFileFailed: "حذف فایل با مشکل رو به رو شد.",
    deleteSelectedFiles: "فایل ها با موفقیت حذف شدند",
    alt: "متن جایگزین (alt)",
    chooseImage: "انتخاب تصویر",
    emptyImage: "تصویری انتخاب کنید!",
    descriptionPlaceHolder: "توضیحات مربوطه را بنویسید",
    words: "کلمه",
    characters: "کاراکتر",
    uploadImage: "آپلود رسانه",
    ThumbnailTitle: "تصویر شاخص",
    loading: "درحال بارگذاری...",
    makePassword: "ایجاد رمز عبور",
    addImage: "افزودن تصویر",
    imageName: "نام فایل",
    ownerMedia: "ناشر",
    insertMedia: "درج فایل",
    insert: "درج",
    linkCopied: "لینک کپی شد.",
    uploadSuccess: "آپلود با موفقیت انجام شد",
    editFile: "فایل با موفقیت ویرایش شد",
    editFileFailed: "ویرایش فایل با مشکل رو به رو شد.",
    tableAdded: "جدول ایجاد شد",
    tableAddingFailed: "افزودن جدول با مشکل مواجه شد.",
    deleteTable: "جدول با موفقیت حذف شد",
    deleteTableFailed: "حذف جدول با مشکل رو به رو شد.",
    tableEdited: "جدول ویرایش شد.",
    tableEditingFailed: "ویرایش جدول با مشکل مواجه شد.",
    selfFiles: "فایل‌های من",
    adminsFiles: "فایل‌های مدیران سایت",
    everyBodyFiles: "فایل‌های همه",
    uploading: "درحال آپلود...",
    uploadDone: "آپلود شد!",
    allTypes: "همه فرمت‌ها",
    image: "تصویر",
    video: "ویدیو",
    document: "سند",
    chooseVideo: "انتخاب ویدیو",
    multiImport: "انتخاب رسانه‌ها",
    filesTable: "فایل‌های ذخیره شده",
    lastUpdate: "آخرین بروزرسانی",
    search: "جستجو",
    from: "از",
    labelRowsSelect: "ردیف",
    labelRowsPerPage: "",
    firstAriaLabel: "صفحه اول",
    firstTooltip: "صفحه اول",
    previousAriaLabel: "صفحه قبل",
    previousTooltip: "صفحه قبل",
    nextAriaLabel: "صفحه بعد",
    nextTooltip: "صفحه بعد",
    lastAriaLabel: "صفحه آخر",
    lastTooltip: "صفحه آخر",
    exportTitle: "دریافت فایل خروجی",
    exportAriaLabel: "دریافت فایل خروجی",
    exportCSVName: "دریافت خروجی CSV",
    emptyDataSourceMessage: 'محتوایی برای نمایش وجود ندارد!',
    addTooltip: 'افزودن',
    deleteTooltip: 'پاک کن',
    editTooltip: 'ویرایش سریع',
    filterTooltip: 'فیلتر',
    deleteText: 'آیا از حذف این ردیف مطمئنید؟',
    cancelTooltip: 'لغو',
    saveTooltip: 'ذخیره',
    rowsSelected: 'ردیف انخاب شده',
    uploadedDate: "زمان آپلود",
    linkPlaceholder: "یک آدرس اینترنتی وارد کنید",
    number: "عدد",
    icon: "آیکون",
    link: "لینک ",
    filters: "فیلتر‌ها",
    chooseColor: "انتخاب رنگ",
    chooseFormat: "انتخاب فرمت",
    updateTime: "بروزرسانی",
    created_at: "تاریخ ایجاد",
    updated_at: "تاریخ بروزرسانی",
    gallery: 'گالری تصاویر',
    requestedToDelete: "درخواست حذف ویترین ارسال شد!",
    pageNotFound: "این صفحه در دسترس نیست!",
    confirmationStatusDescription: "وضعیت تایید اطلاعات",
    confirmationStatusFilter: "وضعیت تایید",
    confirmStatus: "وضعیت تایید",
    userConfirmationStatus: "وضعیت تایید اطلاعات کاربر",
    confirmed: "تایید شده",
    unConfirmed: "در انتظار تایید",
    all: "همه",
    price: "قیمت",
    changeCategories: "تغییر دسته‌بندی‌",
    seoDescription: "توضیح اجمالی",
    welcomeToPanel: "به پنل کاربری خوش آمدید!",
    agreement: "شرایط استفاده",
    pleaseConfirmTerms: "لطفا صفحه شرایط استفاده را مطالعه نموده و تیک تایید را بزنید.",
    rulesConfirmation: "موافقم و آن را می‌پذیرم.",
    with: "با ",
    thumbnail: "تصویر",
    creator: "ناشر",
    edit: "ویرایش",
    view: "مشاهده",
    activity: 'عملیات',
    details: 'جزئیات',
    chooseCategory: "انتخاب دسته‌بندی‌",
    maxGallerySizeIs9: "حداکثر تصاویر گالری ۹ عدد است!",
    manageComments: "مدیریت دیدگاه‌ها",
    manageCategories: "مدیریت دسته‌بندی‌ها",
    usersManagement: "مدیریت کاربران",
    allUsers: "همه کاربران",
    usersActivity: "فعالیت کاربران",
    managePages: "مدیریت صفحات",
    manageContact: "فرم تماس",
    siteSettings: "تنظیمات سایت",
    siteInformation: "تنظیمات اصلی سایت",
    manageSlideShows: "اسلایدر صفحه‌اصلی‌",
    manageAllSlideShows: "مدیریت اسلایدرها‌",
    manageBanners: "مدیریت بنر‌ها",
    manageHomeBanners: "اسلایدر بنر صفحه‌اصلی",
    editSlideShow: "ویرایش اسلایدشو‌",
    custom_css: "کد CSS اضافی",
    custom_js: "کد Java Script اضافی",
    custom_head: "کد اضافه در <head> سایت",
    custom_body: "کد اضافه در <body> سایت",
    custom_code: "کد اضافی",
    siteContactInformation: "اطلاعات تماس سایت",
    moreInfo: "اطلاعات بیشتر",
    makeCategory: "ایجاد دسته‌بندی",
    editCategory: "ویرایش دسته‌بندی",
    categoryName: "نام دسته",
    categoryParentName: "دسته والد",
    categories: "دسته‌بندی‌ها",
    pleaseChooseCategoriesFirst: "لطفا ابتدا دسته‌بندی را انتخاب کنید!",
    category: "دسته‌بندی‌",
    chooseSubCategory: "انتخاب زیر دسته‌",
    chooseMainCategory: "انتخاب دسته‌ اصلی",
    removeImage: 'حذف تصویر',
    viewCategory: 'مشاهده دسته‌بندی',
    username: "نام کاربری",
    userName: "نام و نام‌خانوادگی",
    confirmationStatus: "تایید اطلاعات",
    registerDate: "تاریخ ثبت‌نام",
   creationDate: "تاریخ ثبت",
    changeRole: "تغییر سطح دسترسی",
    role: "سطح دسترسی",
    allRoles: "تمام سطوح دسترسی",
    exportUsersList: "دانلود فهرست کاربران",
    addUser: "کاربر جدید",
    editUser: "ویرایش کاربر",
    editDetails: "ویرایش پروفایل",
    dataEdited: "اطلاعات شما ویرایش شد.",
    dataEditingFailed: "در ثبت اطلاعات مشکلی به وجود آمده است.",
    deleteData: "اطلاعات حذف شد.",
    deleteDataFailed: "در حذف اطلاعات مشکلی به وجود آمده است.",
    admin: "سوپر ادمین",
    user: "کاربر",
    supportUser: "پشتیبانی",
    product_manager: "ادمین محصولات",
    support: "پشتیبانی",
    adminType: "مدیران سایت",
    normalType: "سایر کاربران",
    usersLog: "فعالیت‌های کاربران",
    saveCode: "ذخیره کد",
    writeYourCodehere: "کد خود را اینجا بنویسید",
    customCodeTitle: "کد‌های مورد نیاز خود را اضافه کنید!",
    customCodeText: "در این قسمت می‌توانید کد‌های مورد نیاز خود را در بخش‌های مختلف سایتتان اضافه و آن‌ها را سفارشی‌سازی کنید!",
    main_phone: "شماره تلفن سایت",
    main_email: "ایمیل سایت",
    main_mobile: "شماره موبایل سایت",
    main_address: "آدرس",
    facebook: "لینک Facebook",
    linkedin: "لینک LinkedIn",
    pinterest: "لینک Pinterest",
    instagram: "لینک Instagram",
    twitter: "لینک Twitter",
    whatsapp: "لینک Whatsapp",
    telegram: "لینک Telegram",
    headerAndFooter: "مدیریت هدر و فوتر",
    short_description: "توضیح کوتاه سایت",
    footer_text: "متن توضیح فوتر",
    footer_certificates: "کد نماد‌های فوتر",
    map_script: "کد نقشه صفحه تماس",
    bg_image: "تصویر پس‌زمینه",
    gradientBg: "پس‌زمینه گردینت",
    solidBg: "پس‌زمینه رنگ ساده",
    imageBg: "پس‌زمینه با تصویر",
    gradientBgFirstColor: "رنگ اول گردینت",
    gradientBgSecondColor: "رنگ دوم گردینت",
    bg_type: "نوع تصویر پس زمینه",
    slideShowImages: "المان‌های تصویری",
    SlideShowContent: "محتوای اسلایدشو",
    nextStep: "بخش بعدی",
    mainImageSlide: "تصویر اصلی اسلاید",
    contactInformation: "اطلاعات تماس سایت",
    footerCertificationTitle: "کد مربوط به نماد ها",
    footerCertificationText: "در این قسمت می‌توانید کد‌های دریافتی از سازمان های مختلف مانند نماد اعتماد، رسانه‌های دیجیتال و... را قرار دهید.",
    mapScriptTitle: "کد نقشه",
    mapScriptText: "در این قسمت می‌توانید کد‌های دریافتی از پلتفرم های مختلف نمایش نقشه مانند Google Map را قرار دهید، تا در صفحه تماس نشان داده شوند.",
    saveChanges: "ذخیره تغییرات",
    adminDashboard: "داشبورد مدیریت",
    userDashboard: "داشبورد کاربر",
    currencies: "واحد‌های پولی",
    addContactInformation: "اطلاعات تماس ویترین",
    phoneNumber: "شماره تماس",
    addPhoneNumber: "افزودن شماره",
    addEmail: "افزودن ایمیل",
    relatedLinks: "لینک‌های مرتبط",
    websiteLink: "لینک وب‌سایت",
    facebookLink: "لینک فیسبوک",
    whatsappLink: "شماره واتس‌اپ",
    telegramLink: "لینک تلگرام",
    instagramLink: "لینک اینستاگرام",
    twitterLink: "لینک توئیتر",
    websitePlaceHolder: "https://yourwebsite.com",
    facebookPlaceHolder: "https://facebook.com/your_page",
    whatsappPlaceHolder: "+9712345678",
    telegramPlaceHolder: "https://t.me/your_number",
    instagramPlaceHolder: "https://instagram.com/your_page",
    twitterPlaceHolder: "https://twitter.com/your_page",
    phoneIsWrong: "شماره تلفن اشتباه است.",
    youtube: "یوتیوب",
    addFromYoutube: "افزودن ویدیو از یوتیوب",
    addYoutubeLinkHere: "لطفا یک لینک ویدیو یوتیوب در فیلد پایین بنویسید!",
    addVideo: "افزودن ویدیو",
    youtubeLink: "لینک ویدیو از یوتیوب",
    back: "بازگشت",
    wrongURlForYoutube: "لینک اشتباه است!",
    toggleDark: "حالت شب",
    toggleLight: "حالت روز",
    addMainDetails: "اطلاعات اصلی ویترین",
    addImages: "تصاویر ویترین",
    primaryAdImage: "تصویر اصلی ویترین",
    savedFiles: "فایل‌های آپلود شده",
    fileSize20MB: "حجم فایل باید کمتر از 20MB باشد!",
    fileSize10mb: "حجم فایل باید کمتر از 10MB باشد!",
    fileSize100mb: "حجم فایل باید کمتر از 100MB باشد!",
    fileSize2GB: "حجم فایل باید کمتر از 2GB باشد!",
    addPreviewToVideo: "افزودن پیش‌نمایش به ویدیو",
    doYouWantToAddThumbnail: "آیا قصد افرودن تصویر پیش‌نمایش به این ویدیو را دارید؟",
    addPreviewImage: "افزودن پیش‌نمایش",
    addVideoWithoutPreview: "پیش‌نمایش نمی‌خواهم",
    adsGallery: "گالری ویترین",
    removeItem: "حذف آیتم",
    addItem: "افزودن آیتم",
    address: "آدرس",
    addressAndLocation: "آدرس و لوکیشن",
    commentEdited: "کامنت ویرایش شد",
    commentAdded: "کامنت ایجاد شد",
    commentAddingFailed: "افزودن کامنت با مشکل مواجه شد.",
    commentEditingFailed: "ویرایش کامنت با مشکل مواجه شد.",
    commentRemoved: "کامنت با موفقیت حذف شد",
    rating: "امتیاز",
    comment: "دیدگاه",
    comments: "دیدگاه‌ها",
    editComment: "ویرایش دیدگاه",
    addComment: "افزودن دیدگاه",
    chooseAdForComment: "انتخاب ویترین برای کامنت",
    noAds: "ویترین یافت نشد!",
    commentForReplayDescription: "اگر قصد پاسخ به کامنتی را دارید از اینجا انتخاب کنید",
    parentCommentDesc: "شما درحال پاسخ دادن به کامنت زیر هستید:",
    site_logo: "لوگو سایت",
    favicon: "نمادک سایت (FavIcon)",
    square_logo: "لوگو مربع",
    page_header: "هدر صفحات داخلی",
    pagination_count: "تعداد آیتم در هر صفحه",
    page_count: "تعداد صفحه برای لود Ajax",
    app_name: "نام وب سایت",
    youtubeChanel: "لینک کانال یوتیوب",
    youtubePlaceHolder: "https://www.youtube.com/channel/your_chanel",
    viewPreview: "پیش نمایش",
    userLikes: "تعداد لایک کاربران",
    adInfo: "اطلاعات ویترین",
    viewAd: "مشاهده ویترین",
    pleaseChooseYourLocation: "لطفا موقعیت خود را مشخص کنید!",
    fileInUse: "این فایل درحال استفاده است!",
    backToHome: "بازگشت",
    allowed: "مجاز",
    not_allowed: "غیرمجاز",
    expired: "منقضی شده",
    emptyTableCells: "جدول خالی است!",
    AddTable: "ساخت جدول",
    EditTable: "ویرایش جدول",
    TableBuilder: "جدول ساز",
    tableName: "نام جدول",
    makeTable: "ساخت جدول",
    chooseTableStructure: "تعداد ردیف و ستون جدول خود را مشخص نمایید!",
    columns: "ستون‌ها",
    rows: "ردیف‌ها",
    addRows: "افزودن ردیف",
    addColumns: "افزودن ستون",
    buildTable: "ساخت جدول",
    withHeading: "جدول همراه با سربرگ",
    withoutHeading: "جدول بودن سربرگ",
    tableTdPlaceholder: "محتوای خود را بنویسید...",
    shortcode: "کد کوتاه",
    insertTable: "درج جدول",
    manageCategoriesOrder: "مدیریت ترتیب دسته‌بندی‌ها",
    editSubMenuOrder: "ترتیب زیر دسته",
    noCategoryFound: "دسته‌ای یافت نشد!",
    youAreEditingParentCategoriesOrder: "شما درحال مرتب‌سازی دسته‌بندی‌های اصلی هستید!",
    youAreEditingCategoriesOrder: "درحال مرتب‌سازی زیر دسته:‌ ",
    youAreEditingParentCategoriesOrderDesc: "با کلیک روی دکمه ویرایش زیرمجموعه هر دسته را مرتب کنید.",
    update: "بروزرسانی",
    rate: "امتیاز",
    pageInfo: "اطلاعات صفحه",
    remove: "حذف",
    deleteIt: "پاک شود",
    active: "فعال",
    not_active: "غیرفعال",
    activeStatus: "وضعیت",
    addSlideShow: "افزودن اسلایدشو",
    chooseAdForSlide: "انتخاب ویترین برای اسلاید",
    banner_image: "تصویر بنر",
    addBanner: "افزودن بنر",
    editBanner: "ویرایش بنر",
    pageTitle: "تیتر صفحه",
    addPage: "افزودن صفحه",
    makePage: "ایجاد صفحه",
    editPage: "ویرایش صفحه",
    viewPage: "مشاهده صفحه",
    youCantDeletePermanentPages: "امکان حذف صفحات اصلی وجود ندارد!",
    manageFAQ: "پرسش‌های متداول",
    addFAQ: "افزودن پرسش و پاسخ",
    editFAQ: "ویرایش پرسش و پاسخ",
    question: "سوال",
    answer: "پاسخ",
    bannerTitle: "تیتر بنر",
    wrongPercent: "درصد اشتباه",
    discount_banner_1: "بنر ۱ صفحه تخفیف تکی",
    discount_banner_2: "بنر ۲ صفحه تخفیف تکی",
    bannerPosition: "موقعیت بنر",
    sliderTitle: "تیتر اسلاید",
    primary_button_text:'متن دکمه اصلی',
    primary_button_icon:'آیکون دکمه اصلی',
    primary_button_link:"لینک دکمه اصلی",
    manageAdsComments:"دیدگاه ویترین‌ها",
    chooseItemForComment:"انتخاب آیتم برای کامنت",
    noItem:"آیتمی یافت نشد!",
    term_of_use:"شرایط استفاده",
    tickets: "تیکت پشتیبانی",
    manageMessages: "مدیریت پیام‌ها",
    manageTickets: "مدیریت تیکت‌ها",
    manageDepartments: "مدیریت دپارتمان‌ها",
    requestType: "نوع درخواست",
    supportRequestFromDepartment: "پشتیبانی سیستم",
    supportRequestForProduct: "پشتیبانی محصول",
    sendFile: "ارسال فایل",
    ticket_sender: "ارسال کننده",
    ticket_receiver: "دریافت کننده",
    ticket_title: "موضوع",
    ticket_status: "وضعیت",
    ticket_edited_at: " آخرین ارسال",
    sendMessage: "ارسال پیام",
    backToTickets: "بازگشت به تیکت‌ها",
    deleteTicket: "تیکت حذف شد!",
    deleteTicketFailed: "حذف تیکت با مشکل مواجه شد!",
    ticket_details: "اطلاعات تیکت",
    ticket_sent: "تیکت ارسال شد!",
    sendFastTicket: "ارسال سریع پیام",
    sendMessageTo: "ارسال پیام به",
    addTicket: "ارسال تیکت",
    send: "ارسال",
    messageText: "متن پیام",
    gotToTicketPage: "صفحه پیام‌ها",
    removeRequest: 'حذف درخواست',
    related_admin: "ادمین مربوطه",
    department: "دپارتمان",
    departments: "دپارتمان‌ها",
    low: "کم",
    medium: "متوسط",
    high: "زیاد",
    subject: "موضوع",
    message: "پیام",
    priority: "اولویت",
    unread: "در انتظار بررسی",
    read: "خوانده شده",
    sentTicket: "ارسال شده",
    sent: "ارسال شده",
    referToMe: "ارجاع شده به من",
    resumeOrder: "ادامه سفارش",
    resume: "ادامه",
    mobileNumber: "شماره موبایل",
    status: "وضعیت",
    payed: "پرداخت شده",
    not_used: "استفاده نشده",
    used: "استفاده شده",
    voucher: "ووچر",
    voucher_expired_at: "زمان انقضا",
    getVoucher: "دریافت ووچر",
    unique_key: "کد یکتا",
    not_use: "استفاده نشده",
    withoutExpire: "بدون انقضا",
    dataRemoved: "اطلاعات با موفقیت حذف شد",
    dataRemovingFailed: "حذف اطلاعات با مشکل رو به رو شد.",
    buyer: "خریدار",
    purchasedVouchers: "تخفیفات فروخته شده",
    singular_price: "قیمت واحد",
    viewVouchers: "مشاهده ووچرها",
    viewVoucher: "مشاهده ووچر",
    doesntHave: "ندارد",
    isThisFieldRequired:"فیلد ضروری!",
    field_type:"نوع فیلد",
    text:"متن",
    long_text:"متن طولانی",
    select_field:"فیلد انتخابی",
    multi_select_field:"فیلد چند انتخابی",
    options:"گزینه‌ها",
    pressEnterToMakeEachOption:"برای ایجاد هر گزینه اینتر را بزنید!",
    units:"واحد‌ها",
    newsletterSubscribers:"اعضای خبرنامه",
    menuImage: "تصویر داخل صفحه",
    changeColor: "تغیر رنگ",
    bg_color: "رنگ پس‌زمینه",
    main_color: "رنگ اصلی",
    content_type: "نوع محتوا",
    reviews: "نقد و بررسی",
    none: "هیچکدام",

    /*Dedicated*/
    uploadVideo:"آپلود ویدیو",
    theCopy:"تمام حقوق برای",
    all_rights_reserved:"محفوظ است",
    logout:"خروج",
    categoryEnglishName:"نام دسته (انگلیسی)",
    en_description:"توضیح اجمالی (انگلیسی)",
    uploadVideoDesc:"فایل ویدیو‌ خود را در این قسمت رها کنید و یا از طریق دکمه اقدام نمایید.",
    chooseVideoFile:"انتخاب فایل ویدیو",
    programTitle:"تیتر برنامه",
    makeProgram:"انتخاب زمان پخش",
    saveInfo:"ذخیره اطلاعات",
    home:"خانه",
    myPrograms:"ویدیو‌های من",
    delete:"حذف",
    videoDetails:"اطلاعات ویدیو",
    videoTiming:"انتخاب زمان انتشار",
    chooseDate:"انتخاب تاریخ",
    choose:"انتخاب",
    publishTime:"زمان انتشار",
    managePrograms:"مدیریت برنامه‌ها",
    pending:"در انتظار تایید",
    channelsList:"فهرست کانال‌ها",
    viewChannel:"پخش زنده",
    viewingChannel:"درحال مشاهده",
    topPrograms:"ویدیوهای برتر",
    youAreViewingTheDemo:"شما درحال مشاهده پیش‌نمایش ویدیو می‌باشید.",
    mySchedules:"جدول پخش من",
    newTiming:"زمان‌بندی جدید",
    editProgram:"ویرایش اطلاعات",
    manageSchedules:"مدیریت زمان‌بندی‌ها",
    manageChannels:"مدیریت شبکه‌ها",
    manageOrganizations:"مدیریت سازمان‌ها",
    channelName:"نام شبکه",
    channelEnglishName:"نام شبکه (انگلیسی)",
    editChannel:"ویرایش شبکه",
    makeChannel:"ایجاد شبکه",
    activeStatusDescription:"وضعیت",
    commentSent:"دیدگاه شما ارسال و پس از تایید در سایت نمایش داده خواهد شد.",
    submit:"ثبت",
    submitYourComment:"دیدگاه خود را ثبت کنید",
    usernameHint:"فقط حروف و اعداد انگیسی",
    programsSchedule:"برنامه‌ها",
    tehran:"تهران",
    baghdad:"بغداد",
    dameshgh:"دمشق",
    kabul:"کابل",
    riaz:"ریاض",
    live:"درحال پخش",
    contentEdited:"محتوا ویرایش شد",
    contentEditingFailed:"در ویرایش محتوا مشکلی وجود دارد",
    noScheduledVideo:"ویدیو زمان‌بندی شده‌ای وجود ندارد",
    usersComments:"دیدگاه کاربران",
    dontMakeGap:"لطفا بین ویدیو‌ها فاصله نیندازید",
    timeIsTaken:"امکان انتخاب این زمان وجود ندارد",
    availableFormats:"فرمت‌های قابل قبول",
    videoSubmitted:"اطلاعات ویدیو ذخیره شد",
    videoQueuedToCheck:"ویدیو جهت بررسی در صف قرار گرفت",
    admin_panel:"پنل ادمین",
    programHasSchedule:"امکان حذف ویدیو زمان بندی شده وجود ندارد",
    dayPlay:"پخش امروز",
    to:"تا",
    scheduled:"زمانبندی شده",
    played:"پخش شده",
    allSchedules:"همه زمان‌بندی‌ها",
    viewAll:"مشاهده همه",
    weekPlay:"پخش هفته",
    monthPlay:"پخش ماه",
    profile:"پروفایل",
    myTransactions:"تراکنش‌های من",
    myCardsPageTitle:"کارت‌های من",
    myCardsEmpty:"هنوز کارتی ذخیره نشده. می‌توانید از پایین کارت اضافه کنید.",
    paramPayCvv2:"CVV2",
    paramPayBankGuessPrefix:"بانک:",
    paramPayCardError_invalid_card_number:"شماره کارت باید بین ۱۳ تا ۱۹ رقم باشد.",
    paramPayCardError_invalid_card_luhn:"شماره کارت معتبر نیست (الگوریتم کنترل).",
    paramPayCardError_invalid_card_expiry:"تاریخ انقضا نامعتبر است یا گذشته است.",
    paramPayCardError_invalid_cvv:"کد امنیتی کارت (CVV) نامعتبر است.",
    paramPayCardDefaultPay:"کارت پیش‌فرض",
    paramPayCardDefaultFailed:"تنظیم کارت پیش‌فرض انجام نشد.",
    checkoutNoSavedCards:"برای پرداخت کارت ذخیره‌شده ندارید.",
    checkoutChangeCard:"تعویض کارت",
    checkoutAddCard:"افزودن کارت",
    checkoutPickAnotherCard:"کارت دیگری انتخاب کنید",
    checkoutPickCardWarning:"یک کارت انتخاب کنید یا کارت جدید اضافه کنید.",
    iyzipayEmailRequired:"برای ذخیره کارت و پرداخت، ایمیل معتبر لازم است. لطفاً از پروفایل ایمیل خود را وارد کنید.",
    iyzipayEmailRequiredProfile:"برای ذخیره کارت، در فیلد بالا یک ایمیل معتبر وارد کنید.",
    checkoutSavedCardTitle:"کارت پرداخت",
    transactionTrackingCode:"کد تراکنش",
    youHavePendingWithdrawRequest:"شما یک درخواست واریز وجه فعال دارید",
    pleaseVerifyFirst:"لطفا ابتدا اطلاعات خود را تکمیل کنید",
    transactionType:"نوع تراکنش",
    depositMoney:"شارژ کیف پول",
    depositMoneyDescription:"مقدار مورد نظر برای شارژ کیف پول خود را در این قسمت وارد کنید.",
    withdrawMoney:"برداشت از کیف پول",
    withdrawMoneyDescription:"مقدار مورد نظر برای برداشت از کیف پول خود را در این قسمت وارد کنید.",
    deposit:"شارژ",
    withdraw:"برداشت",
    amount:"مبلغ",
    withdrawRequest: "درخواست واریز",
    myWalletBalance: "موجودی کیف پول",
    bio: "درباره من",
    logOutOnly: "خروج",
    myOrders: "سفارش‌‌های من",
    related_channels: "کانال‌های مرتبط",
    until_description: "هزینه هر ثانیه پخش این کانال، در بازه‌های زمانی:",
    until_4: " ۰۰:۰۰ تا ۳:۵۹",
    until_8: " ۰۴:۰۰ تا ۷:۵۹",
    until_12: " ۰۸:۰۰ تا ۱۱:۵۹",
    until_16: " ۱۲:۰۰ تا ۱۵:۵۹",
    until_20: " ۱۶:۰۰ تا ۱۹:۵۹",
    until_24: " ۲۰:۰۰ تا ۲۳:۵۹",
    channel: "کانال",
    total_likes: "لایک ویدیو",
    total_visits: "بازدید ویدیو",
    duration_limit_description: "میزان تغییر هزینه بر اساس طول ویدیو (عدد در مبلغ بدست آمده ضرب می‌شود)",
    duration_5: " کمتر از ۵ دقیقه",
    duration_15: "۵ تا ۱۵ دقیقه",
    duration_30: "۱۵ تا ۳۰ دقیقه",
    duration_60: "۳۰ تا ۶۰ دقیقه",
    duration_90: "۶۰ تا ۹۰ دقیقه",
    duration_120: "۹۰ دقیقه به بالا",
    editVideo: "ویرایش ویدیو",
    manageWallets: "مدیریت کیف پول‌ها",
    manageWallet: "مدیریت کیف پول‌",
    manageUserWallet: "کیف پول‌ کاربر",
    inventory: "موجودی",
    balance: "موجودی",
    giftToUser: "هدیه به کاربر",
    giftMoneyDescription: "مبلغ مورد نظر برای شارژ هدیه کیف پول کاربر را مشخص کنید",
    giftCharge: "شارژ هدیه",
    description: "توضیح",
    register_gift: "هدیه ثبت نام",
    viewMore: "مشاهده بیشتر",
    sendComment: "ارسال پیام",
    yourComment: "پیام شما",
    contactForm: "فرم تماس",
    contactFormDesc: "جهت ارسال انتقاد، پیشنهاد و سایر موارد از طریق این فرم با ما در ارتباط باشید.",
    fullName: "نام و نام‌خانوادگی",
    messageSentThanks: "با سپاس از همراهی شما! پیام شما ارسال شد.",
    visitsChart: "نمودار بازدید‌ها",
    programsConfirmRequest: "درخواست تایید ویدیو",
    commentConfirmRequest: "درخواست تایید دیدگاه",
    scheduleConfirmRequest: "درخواست تایید زمان‌بندی",
    featureStatusDescription: "در صفحه اصلی نمایش داده شود؟",
    PublishVideo: "انتشار ویدیو",
    minutes: "دقیقه",
    seconds: "ثانیه",
    payWithWallet: "پرداخت با کیف پول",
    start_time: "زمان شروع",
    end_time: "زمان اتمام",
    program_duration: "مدت زمان",
    schedule_price: "هزینه انتشار",
    publishVideoFree: "انتشار رایگان ویدیو",
    publishVideoFreeAdmin: "انتشار رایگان ویدیو (ادمین)",
    youCantAddMoreToSchedule: "زمان بندی قبلی شما هنوز تایید نشده است",
    doYouWanaDeleteSchedule: "آیا قصد پاک کردن زمان‌بندی و بازگشت پول را دارید؟",
    scheduleCantRemoved: "زمان‌بندی وارد مرحله اجرا شده است",
    moneyReturnGaranty: "در صورت عدم تایید ویدیو، مبلغ به کیف پول شما بازگردانده می‌شود.",
    adminWalletLow: "موجودی کیف پول ادمین کم می‌باشد",
    schedulePrice: "هزینه زمان‌بندی ویدیو ",
    error404: "۴۰۴ - صفحه مورد نظر یافت نشد",
    error404Desc: "متاسفانه صفحه مورد نظر یافت نشد",
    monitoring: "Monitoring",
    registerCreator: "ثبت نام تولید کنندگان ویدیو",
    topCreators: "برترین‌های هفته",
    priceVideo: "هزینه مشاهده ویدیو",
    priceDownload: "هزینه دانلود ویدیو",
    slug: "نام یکتا",
    slug_desc: "فقط انگلیسی و غیر قابل تغییر",
    chanelInstallationDescription1: " جهت اجرای پخش زنده شبکه، آیا یک سرور جانبی با APP_CHANNEL= ",
    chanelInstallationDescription2: " وجود دارد؟ ",
    manageQuestionsOrder: "مدیریت ترتیب سوالات",
    currentPlaying: "درحال پخش",
    manageLiveEvents: "مدیریت رویداد زنده",
    eventName:"نام رویداد زنده",
    eventEnglishName:"رویداد زنده (انگلیسی)",
    editEvent:"ویرایش رویداد زنده",
    makeEvent:"ایجاد رویداد زنده",
    eventsList: "فهرست رویداد‌های زنده",
    viewEvent:"رویداد زنده",
    viewingEvent:"درحال مشاهده",
    live_url:"آدرس اینترنتی پخش زنده",
    chooseMinute:"دقیقه",
    chooseHour:"ساعت",
    selectDate:"انتخاب تاریخ",
    makeLiveEvent:"ایجاد رویداد زنده",
    editLiveEvent:"ویرایش رویداد زنده",
    finish_time:"زمان پایان",
    queue:"در صف",
    finished:"پایان یافته",
    shortcutStatusDescription: "به عنوان میان‌برنامه نمایش داده شود؟",
    shortcutStatusDescriptionMore: "(در فهرست برنامه‌های عادی نخواهد آمد و برای پرکردن زمان خالی استفاده می‌شود)",
    manageShortcuts: "مدیریت میان‌برنامه‌ها",
    duration: "مدت زمان",
    shortcutAlert: "درصورت نبودن هیچ میان‌برنامه‌ای، برنامه‌ها به صورت رندوم به عنوان میان‌برنامه نمایش داده خواهند شد.",
    shortcutAlert2: "مدت زمان هر میان برنامه بین ۱ تا ۴۰ ثانیه است. (بهتر است ویدیو در هر بازه زمانی قابل نمایش باشد)",
    finishAd: "رد آگهی",
    ad_force_duration: "مدت زمان نمایش اجباری تبلیغ",
    ad_cycle_duration: "مدت زمان نمایش مجدد تبلیغ",
    adStatusDescription: "به عنوان تبلیغ نمایش داده شود؟",
    adStatusDescriptionMore: "(در فهرست برنامه‌های عادی نخواهد آمد و به عنوان تبلیغ استفاده می‌شود)",
    ad_title: "تیتر تبلیغ",
    ad_link: "لینک تبلیغ",
    manageVideoAds: "مدیریت ویدیو‌های تبلیغاتی",
    adAlert: "درصورت نبودن ویدیو تایید شده، پخش زنده بدون تبلیغات نمایش داده می‌شود.",
    noResultFound: "نتیجه‌ای یافت نشد!",
    organizationName: "نام سازمان",
    numberOfActiveMatches: "تعداد مسابقه فعال",
    numberOfUsers: "تعداد کاربران",
    makeOrganization: "ایجاد سازمان",
    organization: "سازمان",
    organizationAdmin: "مدیر سازمان",
    player: "بازیکن",
    addOrganization: "سازمان جدید",
    editOrganization: "ویرایش سازمان",
    organizationAlias: "نام انگلیسی سازمان",
    organizationDesc: "درباره سازمان",
    duplicateOrganizationName: "نام سازمان تکراری است",
    addMatch: "افزودن مسابقه جدید",
    manageMatches: "فهرست مسابقات",
    chooseMatchType: "نوع مسابقه را انتخاب نمایید.",
    normalMatch: "مسابقه فردی",
    realtimeMatch: "مسابقه گروهی همزمان",
    writeMatchDetails: "اطلاعات مسابقه را وارد نمایید.",
    matchName: "نام مسابقه",
    matchDesc: "توضیح مسابقه",
    settings_correct_answer_score: "امتیاز مثبت",
    settings_correct_answer_score_desc: "تعداد امتیاز مثبت به ازای هر پاسخ درست",
    settings_wrong_answer_score: "امتیاز منفی",
    settings_wrong_answer_score_desc: "تعداد امتیاز منفی به ازای هر پاسخ اشتباه",
    settings_score_per_second: "امتیاز زمان",
    settings_score_per_second_desc: "تعداد امتیاز مثبت به ازای هر ثانیه پاسخ سریع‌تر",
    settings_chat_active: "فعال سازی چت داخل مسابقه؟",
    encyclopediaFile: "فایل دانشنامه",
    chooseFile: "انتخاب فایل",
    has_money_match: "آیا مسابقه جایزه نقدی دارد؟",
    winners_count: "تعداد برنده جایزه نقدی",
    giftFor: "جایزه رتبه",
    endTimeShouldBeAfter: "زمان پایان باید بعد از زمان شروع باشد",
    adminShouldChooseOrganization: "لطفا سازمان مربوطه را انتخاب کنید.",
    toman: "تومان",
    manageMatch: "مدیریت مسابقه",
    realtime: "مسابقه گروهی",
    normal: "مسابقه فردی",
    type: "نوع",
    addQuestion: "افزودن سوال جدید",
    correct_answer: "پاسخ درست",
    wrong_answer_1: "پاسخ اشتباه ۱",
    wrong_answer_2: "پاسخ اشتباه ۲",
    wrong_answer_3: "پاسخ اشتباه ۳",
    questionSaved: "سوال ویرایش شد",
    newQuestionSaved: "سوال جدید ایجاد شد",
    numberOfQuestions: "تعداد سوالات",
    incomplete: "تکمیل نشده",
    not_started: "شروع نشده",
    in_progress: "درحال برگزاری",
    loginToPanel: "ورود به پنل",
    adminsList: "فهرست مدیران",
    playersList: "فهرست بازیکنان",
    playersCount: "تعداد کاربر",
    matchesCount: "تعداد مسابقه",
    addPlayerToOrganization: "افزودن بازیکن",
    fillPrevMobile: "ابتدا شماره موبایل قبلی را وارد کنید",
    newUsersAdded: "کاربران جدید به سازمان اضافه شدند",
    points: "امتیاز",
    viewPlayers: "مشاهده بازیکنان",
    logoImage: "تصویر لوگو",
    accountDetails: "حساب کاربری",
    addOrgDetails: "اطلاعات سازمان",
    helloNewUser: "سلام، خوش آمدید!",
    helloNewUserSetOrg: "لطفا برای استفاده از سیستم اطلاعات سازمان خود را وارد کنید.",
    purchase: "پرداخت",
    sheba_number: "شماره شبا",
    wrongSheba: "شماره شبا اشتباه است. (۲۴ عدد)",
    leaderboard: "لیدربورد",
    noQuestionFound: "پرسشی یافت نشد",
    editMatch: "اطلاعات مسابقه",
    matchRewards: "جوایز مسابقه",
    giftLimit: "موجودی کیف پول",
    viewWallet: "کیف پول",
    totalReward: "جمع جوایز",
    totalRewardMoreThanWallet: "جمع جوایز از موجودی کیف پول بیشتر است.",
    loginRegister: "ورود / ثبت نام",
    managePlans: "مدیریت پلن‌ها",
    makePlan: "ایجاد پلن‌",
    addPlan: "ایجاد پلن‌",
    editPlan: "ویرایش پلن‌",
    duplicatePlanName: "نام پلن‌ تکراری است",
    iconImage: "تصویر آیکون",
    planName: "نام پلن",
    days: "روز",
    colorPicker: "انتخاب رنگ",
    durationHelper: "در صورت مشخص نشدن بدون محدودیت در نظر گرفته می‌شود.",
    discount_price: "قیمت با تخفیف",
    matches_count: "تعداد مسابقه",
    total_players: "تعداد کاربر",
    has_chat: "امکان چت بین کاربران",
    has_realtime: "امکان ایجاد مسابقه گروهی",
    pricePlanHelper: "در صورت خالی بودن رایگان در نظر گرفته می‌شود.",
    has_gift: "امکان ایجاد جایزه نقدی",
    day: "روز",
    week: "هفته",
    month: "ماه",
    year: "سال",
    unlimitedTime: "نامحدود",
    plan_name: "نام پلن",
    free: "رایگان",
    getPlan: "تهیه پلن",
    vendorSettlementsTitle: "تسویه فروشندگان",
    vendorSettlementsDesc: "مبلغ خالص روزانه هر فروشنده. پرداخت‌شده سبز، در انتظار زرد، بیش از ۳ روز قرمز.",
    eInvoicesTitle: "فاکتورهای الکترونیکی",
    eInvoicesDesc: "فاکتور مشتری و کمیسیون فروشنده (e-Fatura / e-Arşiv).",
    settlementDate: "تاریخ تسویه",
    settlementGross: "ناخالص",
    settlementCommission: "کمیسیون",
    settlementPayout: "قابل پرداخت",
    settlementMarkPaid: "پرداخت شد",
    settlementMarkUnpaid: "پرداخت‌نشده کن",
    settlementPaid: "پرداخت‌شده",
    settlementUnpaid: "پرداخت‌نشده",
    settlementColor: "وضعیت رنگی",
    settlementColorGreen: "پرداخت‌شده",
    settlementColorYellow: "در انتظار",
    settlementColorRed: "تأخیری",
    settlementActionSuccess: "انجام شد",
    settlementActionFailed: "خطا در عملیات",
    settlementNoInvoices: "فاکتوری برای دانلود نیست",
    downloadInvoice: "دانلود فاکتور",
    downloadCustomerInvoice: "فاکتور مشتری",
    downloadVendorInvoice: "فاکتور کمیسیون",
    invoiceType: "نوع فاکتور",
    invoiceType_customer_order: "سفارش مشتری",
    invoiceType_vendor_commission: "کمیسیون فروشنده",
    documentType: "نوع سند",
    documentType_efatura: "e-Fatura",
    documentType_earsiv: "e-Arşiv",
    invoiceNo: "شماره فاکتور",
    recipient: "گیرنده",
    invoiceStatus_pending: "در صف",
    invoiceStatus_processing: "در حال ارسال",
    invoiceStatus_sent: "ارسال‌شده",
    invoiceStatus_failed: "خطا",
    invoiceStatus_dead: "خارج از صف",
    invoiceDownloadFailed: "دانلود فاکتور ناموفق بود",
    invoiceRetryQueued: "تلاش مجدد در صف قرار گرفت",
    invoiceNotReady: "فاکتور هنوز آماده نیست",
    retry: "تلاش مجدد",
    refresh: "بروزرسانی",
    all: "همه",
    actions: "عملیات",
    download: "دانلود",
    amount: "مبلغ",
};